import { render, staticRenderFns } from "./vHeader.vue?vue&type=template&id=061442c0&scoped=true"
import script from "./vHeader.vue?vue&type=script&lang=ts"
export * from "./vHeader.vue?vue&type=script&lang=ts"
import style0 from "./vHeader.vue?vue&type=style&index=0&id=061442c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061442c0",
  null
  
)

export default component.exports